import type { Onfido } from 'onfido-sdk-ui';
import Config from '@bonanza-social/toolkit/config';

export const loadOnfido = () =>
  new Promise<typeof Onfido>((resolve, reject) => {
    if (window.Onfido) {
      return resolve(window.Onfido);
    }

    const style = document.createElement('link');

    style.rel = 'stylesheet';
    style.href = `https://sdk.onfido.com/${Config.ONFIDO_VERSION}/style.css`;

    document.head.appendChild(style);

    const script = document.createElement('script');

    script.src = `https://sdk.onfido.com/${Config.ONFIDO_VERSION}`;

    script.onload = () => {
      if (window.Onfido) {
        resolve(window.Onfido);
      } else {
        reject(new Error('Onfido failed to load for an unknown reason'));
      }
    };
    script.onerror = reject;

    document.body.appendChild(script);
  });
